module.exports = __webpack_public_path__ + "static/media/indoor-icon.532442ed.png";